import { render, staticRenderFns } from "./paymentBank.vue?vue&type=template&id=59c67cc0"
import script from "./paymentBank.vue?vue&type=script&lang=js"
export * from "./paymentBank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports